module.exports = __webpack_public_path__ + "img/jf_home_06.e70d23aa.jpg";